<script setup lang="ts">
import { ref } from 'vue'

import mdiChevronDown from '~icons/mdi/chevron-down'
import mdiChevronUp from '~icons/mdi/chevron-up'

// A bold sum row that discloses its per-type breakdown rows (the default slot) on click —
// extracted in the ADA-4472 review, where the two fee sums repeated this markup verbatim.
// A real <button> so the disclosure is keyboard/AT reachable; `amount` arrives pre-formatted
// (like AmortizationTextRow's `value`) and tabular-nums keeps the amount column aligned.
const { label, amount } = defineProps<{
  label: string
  amount: string
}>()

const expanded = ref(false)
</script>

<template>
  <button
    :aria-expanded="expanded"
    type="button"
    class="sum-row d-flex justify-space-between align-center w-100 mb-4"
    @click="expanded = !expanded"
  >
    <span class="text-body-medium font-weight-bold">
      {{ label }}
      <v-icon
        :icon="expanded ? mdiChevronUp : mdiChevronDown"
        size="small"
      />
    </span>
    <span class="text-body-medium font-weight-bold tabular-nums">{{ amount }}</span>
  </button>

  <v-expand-transition>
    <div
      v-show="expanded"
      class="pl-4"
    >
      <slot />
    </div>
  </v-expand-transition>
</template>

<style scoped>
/* A real button styled as a plain text row — same reset idiom as Debt.vue's breakdown-link. */
.sum-row {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  font: inherit;
  text-align: left;
}
</style>
